import { render, staticRenderFns } from "./TextDisplay.vue?vue&type=template&id=fcb95cd8&"
import script from "./TextDisplay.vue?vue&type=script&lang=js&"
export * from "./TextDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports